var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.52,
    height: 53.684,
    viewBox: "0 0 62.52 53.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Exclusion_2",
    x: 0,
    y: 0,
    width: 62.52,
    height: 53.684,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Exclusion_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2-2",
    "data-name": "Exclusion 2",
    d: "M2254.262,35.686a5.426,5.426,0,0,1-2.125-.431l-19.6-8.279a.884.884,0,0,1,0-1.624l5.235-2.211,13.938,5.888a6.55,6.55,0,0,0,5.1,0l13.938-5.888,5.235,2.211a.884.884,0,0,1,0,1.624l-19.6,8.279a5.445,5.445,0,0,1-2.122.431Zm0-8.32a5.427,5.427,0,0,1-2.125-.431l-19.6-8.279a.884.884,0,0,1,0-1.624l5.235-2.211,13.938,5.888a6.55,6.55,0,0,0,5.1,0l13.938-5.888,5.235,2.211a.884.884,0,0,1,0,1.624l-19.6,8.279a5.445,5.445,0,0,1-2.122.428Zm0-8.32a5.427,5.427,0,0,1-2.125-.431l-19.6-8.279a.884.884,0,0,1,0-1.624l19.6-8.279a5.456,5.456,0,0,1,4.249,0l19.6,8.279a.884.884,0,0,1,0,1.624l-19.6,8.279a5.435,5.435,0,0,1-2.125.428Zm8.674-12.119a2.557,2.557,0,1,0,2.543,2.557,2.556,2.556,0,0,0-2.543-2.557Zm-8.9,0a2.557,2.557,0,1,0,2.543,2.557,2.557,2.557,0,0,0-2.543-2.557Zm-8.9,0a2.557,2.557,0,1,0,2.542,2.557,2.557,2.557,0,0,0-2.542-2.557Z",
    transform: "translate(-2223 6)",
    fill: "#002147"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c4bc87f804f28d541b93fcd4883fbb8f.svg";
export { ForwardRef as ReactComponent };